import { SET_DONORS, SET_SELECTED_DONOR } from "../actions/types.js";

const initialState = {
  all: [],
  lastAdded: {
    id: null,
    name: null,
    address: null,
    description: '',
    phone: '',
    email: '',
    contact_person: '',
    contact_person_phone: '',
    responsible_person: '',
    responsible_person_phone: ''
  },
  selectedDonor: null,

  selectedDonors: [],
}

export function donor(state = initialState, action = {}) {
  switch (action.type) {
    case SET_DONORS:
      return Object.assign({}, state, { all: action.donors });
    case SET_SELECTED_DONOR:
      return Object.assign({}, state, { selectedDonor: action.donor });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/donor.js